import useFlashStore from '@shop/store/flash';
import { showApiError as showApiErrorUtil, showTranslatedFlashError } from '@shop/utils/ApiError';

import type { FlashPayload } from '@shop/store/flash.types';

export interface UseFlashResult {
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
  add: (payload: FlashPayload) => void;
  clear: () => void;
  showApiError: (err: unknown) => Promise<void>;
  showTranslatedError: (key: string, domain?: string) => Promise<void>;
}

export function useFlash(): UseFlashResult {
  const flashStore = useFlashStore();

  return {
    success: flashStore.success,
    error: flashStore.error,
    warning: flashStore.warning,
    info: flashStore.info,
    add: flashStore.add,
    clear: flashStore.clear,
    showApiError: async (err: unknown) => showApiErrorUtil(err, flashStore.error),
    showTranslatedError: async (key: string, domain = 'messages') =>
      showTranslatedFlashError(key, flashStore.error, domain),
  };
}
